import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)
// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
    state: {
        dictionaryInfo: {},
		// userInfo:{}
    },
    mutations: {
        setDictionaryInfo (state, val) {
            state.dictionaryInfo = val
        },
		setUserInfo(state,val){
			// state.userInfo = val;
			sessionStorage.setItem("user", JSON.stringify(val))
		}
    },
    actions: {
    },
    modules,
    getters: {
		// userInfo:(state)=> state.userInfo,
		userInfo: (state) => () => {
			let loginInfo = JSON.parse(sessionStorage.getItem('user'))
			return loginInfo
		}
    },
})